//Import resources
import { useContext, useState, useEffect } from "react";

import AuthContext from "../context/AuthProvider";

const Translation = () => {
  //Pull in some variables or functions from the global CONTEXT
  const { displayGuesses } = useContext(AuthContext);

  const [translations, setTranslations] = useState([]);
  const [userTranslations, setUserTranslations] = useState([]);

  const [myWordsConfirmation, setMyWordsConfirmation] = useState("");

  let savedTranslations = [];

  //GET userTranslations from localStorage to compare to when the user hits 'Save Translation'
  const getUserTranslations = () => {
    // Local Storage version
    const userWords = JSON.parse(localStorage.getItem("userTranslations"));
    if (userWords) {
      setUserTranslations(userWords);
      console.log("Got userTranslations from localStorage");
    }
  };

  //run getUserTranslations() ONCE on page load using useEffect()
  useEffect(() => {
    getUserTranslations();
  }, []);

  /* DEFINE 'makeTranslation()' function */
  const makeTranslation = (displayGuess) => {
    //USE TWO ARRAYS to match the prediciton to the Irish word for it.
    const englishWords = [
      "airplane",
      "apple",
      "backpack",
      "banana",
      "baseball bat",
      "baseball glove",
      "bear",
      "bed",
      "bench",
      "bicycle",
      "bird",
      "boat",
      "book",
      "bottle",
      "bowl",
      "broccoli",
      "bus",
      "cake",
      "car",
      "carrot",
      "cat",
      "cell phone",
      "chair",
      "clock",
      "couch",
      "cow",
      "cup",
      "dining table",
      "dog",
      "donut",
      "elephant",
      "fire hydrant",
      "fork",
      "frisbee",
      "giraffe",
      "hair drier",
      "handbag",
      "horse",
      "hot dog",
      "keyboard",
      "kite",
      "knife",
      "laptop",
      "microwave",
      "motorcycle",
      "mouse",
      "orange",
      "oven",
      "parking meter",
      "person",
      "pizza",
      "potted plant",
      "refrigerator",
      "remote",
      "sandwich",
      "scissors",
      "sheep",
      "sink",
      "skateboard",
      "skis",
      "snowboard",
      "spoon",
      "sports ball",
      "stop sign",
      "suitcase",
      "surfboard",
      "teddy bear",
      "tennis racket",
      "tie",
      "toaster",
      "toilet",
      "toothbrush",
      "traffic light",
      "train",
      "truck",
      "tv",
      "umbrella",
      "vase",
      "wine glass",
      "zebra",
    ];
    const irishWords = [
      "eitleán",
      "úll",
      "mála droma",
      "banana",
      "slacán daorchluiche",
      "miotóg daorchluiche",
      "béar",
      "leaba",
      "binse",
      "rothar",
      "éan",
      "bád",
      "leabhar",
      "buidéal",
      "babhla",
      "brocailí",
      "bus",
      "cáca",
      "carr",
      "cairéad",
      "cat",
      "fón póca",
      "cathaoir",
      "clog",
      "tolg",
      "bó",
      "cupán",
      "bord seomra bia",
      "madra",
      "taoschnó",
      "eilifint",
      "hiodrant dóiteáin",
      "forc",
      "friosbaí",
      "sioráf",
      "triomadóir gruaige",
      "mála láimhe",
      "capall",
      "madra te",
      "méarchlár",
      "eitleog",
      "scian",
      "ríomhaire glúine",
      "oigheann micreathonnach",
      "gluaisrothar",
      "luch",
      "oráiste",
      "oigheann",
      "méadar páirceála",
      "duine",
      "píotsa",
      "planda pota",
      "cuisneoir",
      "cianrialú",
      "ceapaire",
      "siosúr",
      "caora",
      "doirteal",
      "clár scátála",
      "scíonna",
      "clár sneachta",
      "spúnóg",
      "peil",
      "comhartha stop",
      "cás",
      "clár surfála",
      "béirín",
      "raicéad leadóige",
      "carbhat",
      "tóstaer",
      "leithreas",
      "scuab fiacla",
      "solas tráchta",
      "traein",
      "trucail",
      "teilifís",
      "scáth fearthainne",
      "vása",
      "gloine fíona",
      "séabra",
    ];
    let irishIndex = englishWords.indexOf(displayGuess);
    let newTranslation = irishWords[irishIndex];
    console.log("Translation is " + displayGuess + "=" + newTranslation);
    //Add the new translation to the 'translations' array for use in the UI
    setTranslations((translations) => [
      ...translations,
      `${displayGuess} = ${newTranslation}`,
    ]);
  };

  //saveTranslation function to save a translation to the database (for the user's 'My Words' list)
  const saveTranslation = (translation) => {
    //getUserTranslations()
    if (userTranslations.includes(translation)) {
      setMyWordsConfirmation(
        `\"${translation}\" is already on your saved \"My Words\" list.`
      );
    } else {
      //Save the translation to the list of userTranslations in localStorage
      localStorage.setItem(
        "userTranslations",
        JSON.stringify([...userTranslations, translation])
      );
      setMyWordsConfirmation(
        `\"${translation}\" has been added to your \"My Words\" list.`
      );

      //Update the list of translations in the UI
      savedTranslations = [...savedTranslations, translation]; //this updates the array of 'savedTranslations'
      setTranslations(
        translations.filter((item) => !savedTranslations.includes(item))
      ); //this filters those savedTranslations out of 'translations' so they don't show up in the UI
    }
    getUserTranslations();
  };

  ///////////////////
  //RETURN this JSX to UI
  return (
    <div className="container d-flex justify-content-center">
      <div>
        <h5
          className={
            myWordsConfirmation.includes("added")
              ? "text-success d-flex justify-content-center"
              : "text-danger d-flex justify-content-center"
          }
        >
          {myWordsConfirmation}
        </h5>
        <ul className="list-unstyled d-flex justify-content-center">
          {displayGuesses.map((displayGuess, i) => {
            return (
              <li key={i}>
                <div className="card m-3 p-2 border-primary text-primary text-center">
                  <h5>{displayGuess}</h5>
                  <button
                    onClick={() => {
                      makeTranslation(displayGuess);
                    }}
                    className="btn btn-outline-primary"
                  >
                    Translate
                  </button>
                </div>
              </li>
            );
          })}
        </ul>

        <ul className="list-unstyled d-flex justify-content-center">
          {translations.map((translation, i) => {
            return (
              <li key={i}>
                <div className="card m-3 p-2 border-success text-success text-center">
                  <h5>{translation}</h5>
                  <button
                    onClick={() => {
                      saveTranslation(translation);
                    }}
                    className="btn btn-outline-success"
                  >
                    Save to 'My Words' list
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Translation;
